import { render, staticRenderFns } from "./StaffBankAccountGrid.vue?vue&type=template&id=bf02805a"
import script from "./StaffBankAccountGrid.vue?vue&type=script&lang=js"
export * from "./StaffBankAccountGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports